import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import React from 'react'
import { Grid, Paper, Typography, Box, CircularProgress } from '@mui/material'
import { useStyles } from './style'
import AssessmentItem from './assessment-item'
import { BannerStatic } from '../../components'

const AssessmentList = () => {
  const classes = useStyles()

  const [assessmentList, setAssessmentList] = React.useState([])

  const [getAssessments] = useEvent([
    {
      eventName: 'msaGetAssessments',
      onSuccess: (payload) => {
        if (payload) {
          setAssessmentList(payload)
        }
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error when getting assessment list.',
          isError: true
        })
      }
    }
  ])

  useEventsOnViewLoad(() => {
    getAssessments.trigger()
  }, [getAssessments])

  const isLoading = getAssessments.isWorking

  return (
    <Box>
      <Grid container classes={{ root: classes.header }}>
        <Grid container direction='row' alignItems='center'>
          <Grid item style={{ flexGrow: 1 }}>
            <Typography tabIndex={0} component='div' variant='h5'>
              Assessments
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Paper
        classes={{ root: classes.tablePaper }}
        tabIndex={0}
        aria-label='Assessment List'
        elevation={0}
      >
        <Grid
          container
          tabIndex={0}
          direction='row'
          alignItems='center'
          className={classes.gridHeader}
          classes={{ root: classes.tableHead }}
          aria-label='List headers, Title, External ID, Last Update'
        >
          <Grid item md={5} sx={{ paddingLeft: 3 }}>Title</Grid>
          <Grid item md={5}>External ID</Grid>
          <Grid item md={2}>Last Update</Grid>
        </Grid>
        {(isLoading) && (
          <Grid
            id='assessments-list-loading'
            container
            direction='row'
            justifyContent='center'
            align='center'
            classes={{ root: classes.loadingAnimation }}
          >
            <CircularProgress size={60} color='primary' />
          </Grid>
        )}
        {!isLoading && assessmentList.map((assessment, key) => (
          <AssessmentItem key={key} index={key} assessment={assessment} />
        ))}
        {(!isLoading && assessmentList.length === 0) && (
          <Grid
            id='assessments-list-not-found'
            container
            direction='row'
            justifyContent='center'
            align='center'
            classes={{ root: classes.loadingAnimation }}
          >
            <Typography variant='h6'>
              No assessments have been created yet. Please contact the admin.
            </Typography>
          </Grid>
        )}
      </Paper>
    </Box>
  )
}

export default AssessmentList
